module.exports = __webpack_public_path__ + "img/logo.5277d099.jpg";